import { Link } from "react-router-dom";
import { BaseIcon } from "../base-icon/base-icon.component";
import "./side-menu.style.scss";
import clsx from "clsx";
import { Badge, Button, Container } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { clearUser } from "../../redux/auth/auth.slice";
import { clearTempData } from "../../redux/temp/temp-data.slice";
import { clearGlobalData } from "../../redux/global/global.slice";
import { BottomSheet } from "react-spring-bottom-sheet";
import React, { useState } from "react";
import logoutImg from "../../assets/images/logout-img.svg";
import { moneyFormatterUtility } from "../../utilities/number/money-formatter.utility";

export const SideMenu = ({ isOpen }) => {
	const citiesList = useSelector((state) => state.globalData?.initData?.city);
	const userCityId = useSelector((state) => state.currentUser?.city?.id);
	const inviteFriendScore = useSelector((state) => state.currentUser?.inviteFriendScore);
	const citySupportPhoneNumber = citiesList?.find((city) => city?.id === userCityId)?.supportPhone;

	const dispatch = useDispatch();

	const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

	const onLogout = () => {
		setIsLogoutModalOpen(true);
	};

	const logout = () => {
		dispatch(clearUser());
		dispatch(clearTempData());
		dispatch(clearGlobalData());
		localStorage.clear();
		window.location.replace("/introduction");
	};

	return (
		<>
			<div
				className={clsx("side-menu-holder", {
					active: isOpen,
				})}
			>
				<ul className="list-unstyled m-0 px-0">
					<li>
						<Link to="/edit-profile" className="side-menu-link">
							<div className="mx-100 pt-150">
								<div className="fw-600 f-12 mb-150 d-flex align-items-center">
									<BaseIcon name="User1" className="ms-50" size={20} />
									<span>ویرایش حساب کاربری </span>
								</div>
								<hr className="side-menu-link-line" />
							</div>
						</Link>
					</li>

					<li>
						<Link to="/rubbishes-price" className="side-menu-link">
							<div className="mx-100 pt-150">
								<div className="fw-600 f-12 mb-150 d-flex align-items-center">
									<BaseIcon name="ListLeft" className="ms-50" size={20} />

									<span>قیمت پسماندِ خشک</span>
								</div>

								<hr className="side-menu-link-line" />
							</div>
						</Link>
					</li>

					<li>
						<Link to="/transactions" className="side-menu-link">
							<div className="mx-100 pt-150">
								<div className="fw-600 f-12 mb-150 d-flex align-items-center">
									<BaseIcon name="DocumentFilled" className="ms-50" size={20} />
									<span>تاریخچۀ تراکنش‌های مالی</span>
								</div>
								<hr className="side-menu-link-line" />
							</div>
						</Link>
					</li>

					<li>
						<Link to="/collects-history" className="side-menu-link">
							<div className="mx-100 pt-150">
								<div className="fw-600 f-12 mb-150 d-flex align-items-center">
									<BaseIcon name="DocumentCheck" className="ms-50" size={20} />
									<span>سوابقِ جمع‌آوری پسماند</span>
								</div>
								<hr className="side-menu-link-line" />
							</div>
						</Link>
					</li>

					<li>
						<Link to="/favorite-addresses" className="side-menu-link">
							<div className="mx-100 pt-150">
								<div className="fw-600 f-12 mb-150 d-flex align-items-center">
									<BaseIcon name="Location1" className="ms-50" size={20} />
									<span>آدرس‌های منتخب</span>
								</div>
								<hr className="side-menu-link-line" />
							</div>
						</Link>
					</li>

					<li>
						<Link to="/invitation" className="side-menu-link">
							<div className="mx-100 pt-150">
								<div className="fw-600 f-12 mb-150 d-flex align-items-center">
									<BaseIcon name="Share1" className="ms-50" size={20} />

									<span className="ms-50">معرفی به دوستان</span>

									<Badge color="primary">
										<div className="dis-vet-center">
											<span>{moneyFormatterUtility(inviteFriendScore ?? 5000)}</span>
											<span className="me-25">تومانء</span>
										</div>
									</Badge>
								</div>

								<hr className="side-menu-link-line" />
							</div>
						</Link>
					</li>

					{/* <li>
						<a href="/mag" target="_blank" className="side-menu-link">
							<div className="mx-100 pt-150">
								<div className="fw-600 f-12 mb-150 d-flex align-items-center">
									<BaseIcon name="Grid4" className="ms-50" size={20} />

									<span>مجلۀ کارو</span>
								</div>

								<hr className="side-menu-link-line" />
							</div>
						</a>
					</li> */}

					<li>
						<a href={`tel:${citySupportPhoneNumber}`} className="side-menu-link">
							<div className="mx-100 pt-150">
								<div className="fw-600 f-12 mb-150 d-flex align-items-center">
									<BaseIcon name="PhoneCall" className="ms-50" size={20} />

									<span>ارتباط با پشتیبانی</span>
								</div>

								<hr className="side-menu-link-line" />
							</div>
						</a>
					</li>
					<li>
						<Link to={"/settings"} className="side-menu-link">
							<div className="mx-100 pt-150">
								<div className="fw-600 f-12 mb-150 d-flex align-items-center">
									<BaseIcon name="Settings" className="ms-50" size={20} />

									<span>تنظیمات</span>
								</div>

								<hr className="side-menu-link-line" />
							</div>
						</Link>
					</li>

					<li>
						<Link to={"/about"} className="side-menu-link">
							<div className="mx-100 pt-150">
								<div className="fw-600 f-12 mb-150 d-flex align-items-center">
									<BaseIcon name="InfoCircle" className="ms-50" size={20} />

									<span>دربارۀ اپلیکیشن کارو</span>
								</div>

								<hr className="side-menu-link-line" />
							</div>
						</Link>
					</li>

					<li>
						<div className="p-0 side-menu-link text-danger" onClick={onLogout}>
							<div className="mx-100 pt-150">
								<div className="fw-600 f-12 mb-150 d-flex align-items-center">
									<BaseIcon name="Logout" className="ms-50" size={20} />
									<span>خروج از حساب کاربری</span>
								</div>

								<hr className="side-menu-link-line" />
							</div>
						</div>
					</li>
				</ul>
			</div>

			<BottomSheet open={isLogoutModalOpen} onDismiss={() => setIsLogoutModalOpen(false)}>
				<Container>
					<div className="py-100">
						<h3 className="fw-900 f-16 mb-50">خروج از حساب کاربری</h3>
						<p className="fw-400 f-12 mb-200">قصد دارین از حساب کاربری‌تون در کارو خارج بشین؟</p>
						<div className="dis-vet-center justify-content-center mb-200">
							<img src={logoutImg} className="img-fluid" />
						</div>
						<div className="d-flex">
							<Button
								block
								outline
								color="danger"
								className="ms-50"
								onClick={() => setIsLogoutModalOpen(false)}
							>
								نه، دستم خورد!
							</Button>
							<Button block color="danger" onClick={logout}>
								بله لطفا
							</Button>
						</div>
					</div>
				</Container>
			</BottomSheet>
		</>
	);
};
